import ApiClient from './ApiClient';

class ContactBookings extends ApiClient {
  constructor() {
    super('bookings', { accountScoped: true });
    this.contactId = null;
  }

  get url() {
    return `${this.baseUrl()}/contacts/${this.contactId}/bookings`;
  }

  get(contactId) {
    this.contactId = contactId;
    return super.get();
  }

  create(contactId, data) {
    this.contactId = contactId;
    return super.create(data);
  }

  update(contactId, id, data) {
    this.contactId = contactId;
    return super.update(id, data);
  }

  delete(contactId, id) {
    this.contactId = contactId;
    return super.delete(id);
  }
}

export default new ContactBookings();
